import { useTranslation } from 'react-i18next';
import { StatsCards } from '../../common/StatsCards/StatsCards';
import type { UserStatisticsResponse } from '../../../types';

interface UserCardsProps {
  stats: UserStatisticsResponse | null;
}

export function UserCards({ stats }: UserCardsProps) {
  const { t } = useTranslation();

  const statItems = [
    {
      title: t('admin.totalUsers'),
      value: stats?.totalUsers ?? 0,
      icon: (
        <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/>
        </svg>
      ),
      iconColorClass: 'stat-color-brand',
    },
    {
      title: t('admin.regularUsers', 'Regular Users'),
      value: stats?.regularUsers ?? 0,
      icon: (
        <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/>
        </svg>
      ),
      iconColorClass: 'stat-color-teal',
    },
    {
      title: t('admin.admins', 'Admins'),
      value: stats?.admins ?? 0,
      icon: (
        <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"/>
        </svg>
      ),
      iconColorClass: 'stat-color-amber',
    },
  ];

  return <StatsCards items={statItems} />;
}
